// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  background: #241f1c;
  color: #fff;
  font-size: 55%;
  height: 100%;
}
body {
  height: 100%;
}
html,
body {
  margin: 0;
  padding: 0;
}
#app {
  height: 100%;
}
.grow {
  flex-grow: 1;
}
@media screen and (max-width: 1500px) {
  html {
    font-size: 45%;
  }
}
body,
input,
input:-webkit-autofill::first-line,
input:-webkit-autofill,
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea,
a {
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  font-size: 1.6rem;
  line-height: 2.8rem;
  letter-spacing: 0.03em;
}
a {
  color: #DAD2D6;
  font-weight: 300;
}
a:hover {
  font-weight: 400;
}
a:active {
  color: #FFAE00;
  font-weight: 400;
}
h1 {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 6.6rem;
  line-height: 110%;
  letter-spacing: 0.01em;
  margin: 3.2rem;
}
h2 {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 5rem;
  line-height: 120%;
  letter-spacing: 0.01em;
  margin: 3.2rem;
}
h3 {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 3.8rem;
  line-height: 120%;
  letter-spacing: 0.01em;
}
h4 {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 2.4rem;
  line-height: 120%;
  margin: 0;
}
h5 {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 2.1rem;
  line-height: 120%;
  margin: 0.2rem;
  word-wrap: break-word;
}
h6 {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 1.6rem;
  line-height: 120%;
  margin: 0;
}
.link {
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  font-size: 1.4rem;
  line-height: 120%;
  letter-spacing: 0.03em;
}
.link:hover {
  font-weight: 400;
}
.button-text {
  font-family: 'Nunito', serif;
  font-weight: 800;
  font-size: 2.1rem;
  line-height: 120%;
  letter-spacing: 0.01em;
}
.table-text {
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  font-size: 1.2rem;
  line-height: 120%;
  letter-spacing: 0.03em;
}
.go2sim-red-text {
  color: #E84230;
}
`, "",{"version":3,"sources":["webpack://./styles/layout.less","webpack://./styles/typography.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;ACCF;ADEA;EACE,YAAA;ACAF;ADGA;;EACE,SAAA;EAAU,UAAA;ACCZ;ADEA;EACE,YAAA;ACAF;ADGA;EACE,YAAA;ACDF;ADIA;EACE;IACE,cAAA;ECFF;AACF;AArBA;;;;;;;;;EASE,iCAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;AAuBF;AApBA;EACE,cAAA;EACA,gBAAA;AAsBF;AAnBA;EACE,gBAAA;AAqBF;AAlBA;EACE,cAAA;EACA,gBAAA;AAoBF;AAjBA;EACE,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AAmBF;AAhBA;EACE,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AAkBF;AAfA;EACE,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;AAiBF;AAdA;EACE,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;AAgBF;AAbA;EACE,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AAeF;AAZA;EACE,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,SAAA;AAcF;AAXA;EACE,iCAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;AAaF;AAVA;EACE,gBAAA;AAYF;AATA;EACE,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;AAWF;AARA;EACE,iCAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;AAUF;AAPA;EACE,cAAA;AASF","sourcesContent":["html {\n  background: #241f1c;\n  color: #fff;\n  font-size: 55%;\n  height: 100%;\n}\n\nbody {\n  height: 100%;\n}\n\nhtml, body {\n  margin:0; padding:0;\n}\n\n#app {\n  height: 100%;\n}\n\n.grow {\n  flex-grow: 1;\n}\n\n@media screen and (max-width: 1500px) {\n  html {\n    font-size: 45%;\n  }\n}","@import 'layout.less';\n@import 'colours.less';\n\nbody,\ninput,\ninput:-webkit-autofill::first-line,\ninput:-webkit-autofill,\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea,\na {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 300;\n  font-size: 1.6rem;\n  line-height: 2.8rem;\n  letter-spacing: 0.03em;\n}\n\na {\n  color: @text-grey;\n  font-weight: 300;\n}\n\na:hover {\n  font-weight: 400;\n}\n\na:active {\n  color: @honey-yellow;\n  font-weight: 400;\n}\n\nh1 {\n  font-family: 'Nunito', serif;\n  font-weight: 800;\n  font-size: 6.6rem;\n  line-height: 110%;\n  letter-spacing: 0.01em;\n  margin: 3.2rem;\n}\n\nh2 {\n  font-family: 'Nunito', serif;\n  font-weight: 800;\n  font-size: 5rem;\n  line-height: 120%;\n  letter-spacing: 0.01em;\n  margin: 3.2rem;\n}\n\nh3 {\n  font-family: 'Nunito', serif;\n  font-weight: 800;\n  font-size: 3.8rem;\n  line-height: 120%;\n  letter-spacing: 0.01em;\n}\n\nh4 {\n  font-family: 'Nunito', serif;\n  font-weight: 800;\n  font-size: 2.4rem;\n  line-height: 120%;\n  margin: 0;\n}\n\nh5 {\n  font-family: 'Nunito', serif;\n  font-weight: 800;\n  font-size: 2.1rem;\n  line-height: 120%;\n  margin: 0.2rem;\n  word-wrap: break-word;\n}\n\nh6 {\n  font-family: 'Nunito', serif;\n  font-weight: 800;\n  font-size: 1.6rem;\n  line-height: 120%;\n  margin: 0;\n}\n\n.link {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 300;\n  font-size: 1.4rem;\n  line-height: 120%;\n  letter-spacing: 0.03em;\n}\n\n.link:hover {\n  font-weight: 400;\n}\n\n.button-text {\n  font-family: 'Nunito', serif;\n  font-weight: 800;\n  font-size: 2.1rem;\n  line-height: 120%;\n  letter-spacing: 0.01em;\n}\n\n.table-text {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 300;\n  font-size: 1.2rem;\n  line-height: 120%;\n  letter-spacing: 0.03em;\n}\n\n.go2sim-red-text {\n  color: @go2sim-red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
